export const EmailConfirmationError = {
  extends: 'Flex',
  flow: 'y',
  align: 'center center',
  gap: 'B',
  Icon: {
    name: 'exclMark',
    size: 'A',
    color: 'red'
  },
  H3: {
    text: '{{ auth.emailConfirmFailed.title | polyglot }}',
    margin: '0'
  },
  P: {
    text: (el, s) => s.error || el.call('polyglot', 'auth.emailConfirmFailed.body'),
    textAlign: 'center',
    color: 'paragraph',
    maxWidth: 'G'
  },
  TryAgainButton: {
    extends: ['Button', 'ClickableItem'],
    text: '{{ common.action.try_again | polyglot }}',
    margin: 'B 0 0',
    width: '100%',
    onClick: async (_, el, s) => {
      s.update({ loading: true })
      await el.call('confirmEmail')
    }
  }
}
